import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {handleErrorResponse} from "../utils/util"
import { USER_ROLE } from "../constants/index"
import {
  TalentViewNewsDetailRetrieveData,
  TalentViewNewsRecommendRetrieveData, type TalentViewNewsRetrieveData,
  TalentViewService, TalentViewNewsDetailUpdateData, TalentViewBookmarkStatusUpdateData,
  TalentViewNewsMobileListData,
} from "api";
import i18n from 'i18next';
import { resetAppState } from "../store/common";

// Get list notification
export const getListNotification = createAsyncThunk(
  "getListNotification",
  async (_, thunkAPI: any) => {
    try {
      const res = await TalentViewService.talentViewNotificationRetrieve() as any;
      if (res) { return res; }
      return thunkAPI.rejectWithValue(i18n.t('MSG_GLOBAL_DATA_LOAD_FAILED'));
    } catch (error: any) {
      return handleErrorResponse(error, USER_ROLE.TALENT, thunkAPI);
    }
  },
);

// Get list news
export const getListNews = createAsyncThunk(
  "getListNews",
  async (data: TalentViewNewsRetrieveData, thunkAPI: any) => {
    try {
      const res = await TalentViewService.talentViewNewsList(data) as any;
      if (res) { return res; }
      return thunkAPI.rejectWithValue(i18n.t('MSG_GLOBAL_DATA_LOAD_FAILED'));
    } catch (error: any) {
      return handleErrorResponse(error, USER_ROLE.TALENT, thunkAPI);
    }
  },
);

// Get list news for mobile
export const getListNewsMobile = createAsyncThunk(
  "getListNewsMobile",
  async (data: TalentViewNewsMobileListData, thunkAPI: any) => {
    try {
      const res = await TalentViewService.talentViewNewsMobileList(data) as any;
      if (res.results.success) { return res; }
      return thunkAPI.rejectWithValue(i18n.t('MSG_GLOBAL_DATA_LOAD_FAILED'));
    } catch (error: any) {
      return handleErrorResponse(error, USER_ROLE.TALENT, thunkAPI);
    }
  },
);

// Get news detail
export const getNewsDetail = createAsyncThunk(
  "getNewsDetail",
  async (data: TalentViewNewsDetailRetrieveData, thunkAPI: any) => {
    try {
      const res = await TalentViewService.talentViewNewsDetailRetrieve(data) as any;
      if (res.success) { return res; }
      return thunkAPI.rejectWithValue(i18n.t('MSG_GLOBAL_DATA_LOAD_FAILED'));
    } catch (error: any) {
      return handleErrorResponse(error, USER_ROLE.TALENT, thunkAPI);
    }
  },
);

// Get news recommend
export const getNewsRecommend = createAsyncThunk(
  "getNewsRecommend",
  async (data: TalentViewNewsRecommendListData, thunkAPI: any) => {
    try {
      const res = await TalentViewService.talentViewNewsRecommendList(data) as any;
      if (res.success) { return res; }
      return thunkAPI.rejectWithValue(i18n.t('MSG_GLOBAL_DATA_LOAD_FAILED'));
    } catch (error: any) {
      return handleErrorResponse(error, USER_ROLE.TALENT, thunkAPI);
    }
  },
);

export const updateNumberOfViews = createAsyncThunk(
  "updateNumberOfViews",
  async (data: TalentViewNewsDetailUpdateData, thunkAPI: any) => {
    try {
      const res = await TalentViewService.talentViewNewsDetailUpdate(data) as any;
      if (res) { return res; }
      return thunkAPI.rejectWithValue(i18n.t('MSG_GLOBAL_DATA_LOAD_FAILED'));
    } catch (error: any) {
      return handleErrorResponse(error, USER_ROLE.TALENT, thunkAPI);
    }
  },
);

export const setNewsBookmark = createAsyncThunk(
  "setNewsBookmark",
  async (data: TalentViewBookmarkStatusUpdateData, thunkAPI: any) => {
    try {
      const res: any = await TalentViewService.talentViewBookmarkStatusUpdate(data);
      if (res.success) {
        return res;
      } else {
        return thunkAPI.rejectWithValue(i18n.t('MSG_GLOBAL_DATA_LOAD_FAILED'));
      }
    } catch (error: any) {
      return handleErrorResponse(error, USER_ROLE.TALENT, thunkAPI);
    }
  },
);

export const setNewsCardBookmark = createAsyncThunk(
    "setNewsCardBookmark",
    async (data: TalentViewBookmarkStatusUpdateData, thunkAPI: any) => {
      try {
        const res: any = await TalentViewService.talentViewBookmarkStatusUpdate(data);
        if (res.success) {
          return res;
        } else {
          return thunkAPI.rejectWithValue(i18n.t('MSG_GLOBAL_DATA_LOAD_FAILED')); 
        }
      } catch (error: any) {
        return handleErrorResponse(error, USER_ROLE.TALENT, thunkAPI);
      }
    },
);

// State ban đầu của Redux
interface loadingState {
  loading: boolean;
  error: string | null;
  success: string | null;
  actionStatus: string;
  actionName: string;
  notifications: any;
  news: any;
  newsDetail: any;
  newsRecommend: any;
  pageSize: any;
  totalNews: any;
  newsMobile: any;
  stepLoading: number;
  limitItems: number;
  totalResultsMobile: number;
  hasMore: boolean;
  canBackPrevPage: boolean;
  totalResultsMobile: number;
  hasMore: boolean;
  currentPageLoading: number;
  pageSizeLoading: number;
  isReloadNews: boolean;
}
const initialState: loadingState = {
  loading: false,
  error: null,
  success: null,
  actionStatus: "idle",
  actionName: "",
  notifications: [],
  news: [],
  newsDetail: {},
  newsRecommend: [],
  pageSize: 6,
  totalNews: 0,
  newsMobile: [],
  stepLoading: 6,
  limitItems: 6,
  totalResultsMobile: 0,
  hasMore: true,
  canBackPrevPage: false,
  totalResultsMobile: 0,
  hasMore: true,
  currentPageLoading: 1,
  pageSizeLoading: 6,
  isReloadNews: false,
};

const updateItemsById = (list, updatedItem) =>
  list.map(item => (item.id === updatedItem.id ? updatedItem : item));

// Create slice reducers and extraReducers
export const loadingSlice = createSlice({
  name: "loadingSlice",
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setCanBackPrevPage: (state, action) => {
      state.canBackPrevPage = action.payload;
    },
    setCurrentPageLoading: (state, action) => {
      state.currentPageLoading = action.payload;
    },
    setHasMore: (state, action) => {
      state.hasMore = action.payload;
    },
    setNewsMobile: (state, action) => {
      state.newsMobile = action.payload;
    },
    setIsReloadNews: (state) => {
      state.isReloadNews = !state.isReloadNews;
    },
    setSuccess: (state, action) => {
      state.success = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      // reset state
      .addCase(resetAppState, () => initialState)
      
      // Get list notification
      .addCase(getListNotification.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.actionStatus = "pending";
      })
      .addCase(getListNotification.fulfilled, (state, action) => {
        state.loading = false;
        state.actionName = "getListAction";
        state.actionStatus = "fulfilled";
        state.notifications = action.payload.data;
      })
      .addCase(getListNotification.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
        state.actionStatus = "rejected";
      })

      // Get list news
      .addCase(getListNews.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.actionStatus = "pending";
      })
      .addCase(getListNews.fulfilled, (state, action) => {
        state.loading = false;
        state.actionName = "getListAction";
        state.actionStatus = "fulfilled";
        state.news = action.payload.results;
        state.totalNews = action.payload.count;
      })
      .addCase(getListNews.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
        state.actionStatus = "rejected";
      })

      // Get list news mobile
      .addCase(getListNewsMobile.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.actionStatus = "pending";
        state.hasMore = false;
      })
      .addCase(getListNewsMobile.fulfilled, (state, action) => {
        state.loading = false;
        state.actionName = "getListNewsMobile";
        state.actionStatus = "fulfilled";

        if(state.currentPageLoading == 1) state.newsMobile = [];

        let countPageLoading = 0;
        state.totalNews = action.payload.count;
        if(state.totalNews == 0) {
          state.currentPageLoading = 1;
          state.newsMobile = [];
        } 
        else {
          const newItems = action.payload.results.data;
          const merged = [...state.newsMobile, ...newItems];
          const uniqueMap = new Map();
          merged.forEach(item => {
            uniqueMap.set(item.id, item);
          });
          state.newsMobile = Array.from(uniqueMap.values());           
          countPageLoading = Math.ceil(state.totalNews / state.pageSizeLoading);
        }
        
        if(state.currentPageLoading >= countPageLoading) state.hasMore = false;
        else state.hasMore = true;
      })
      .addCase(getListNewsMobile.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
        state.actionStatus = "rejected";
      })

      // Get news detail
      .addCase(getNewsDetail.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.actionStatus = "pending";
        state.actionName = "getNewsDetail";
      })
      .addCase(getNewsDetail.fulfilled, (state, action) => {
        state.loading = false;
        state.actionStatus = "fulfilled";
        state.newsDetail = action.payload.data;
      })
      .addCase(getNewsDetail.rejected, (state, action) => {
        state.loading = false;
        // state.error = action.payload as string;
        state.actionStatus = "rejected";
      })

      // Get news recommend
      .addCase(getNewsRecommend.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getNewsRecommend.fulfilled, (state, action) => {
        state.loading = false;
        state.newsRecommend = action.payload.data;
      })
      .addCase(getNewsRecommend.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      // updateNumberOfViews
      .addCase(updateNumberOfViews.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateNumberOfViews.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(updateNumberOfViews.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      // setNewsBookmark
      .addCase(setNewsBookmark.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.actionName = "setNewsBookmark";
      })
      .addCase(setNewsBookmark.fulfilled, (state, action) => {
        state.loading = false;
        state.success = action.payload.message;
        state.newsDetail.is_bookmarked = action.payload.data.is_bookmarked;
      })
      .addCase(setNewsBookmark.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      // setNewsCardBookmark
      .addCase(setNewsCardBookmark.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.actionName = "setNewsCardBookmark";
      })
      .addCase(setNewsCardBookmark.fulfilled, (state, action) => {
        state.loading = false;
        state.success = action.payload.message;
        state.news = updateItemsById(state.news, action.payload.data);
        state.newsMobile = updateItemsById(state.newsMobile, action.payload.data);
        state.newsRecommend = updateItemsById(state.newsRecommend, action.payload.data);
      })
      .addCase(setNewsCardBookmark.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
  },
});

export const {
  setCanBackPrevPage,
  setIsReloadNews,
  setCurrentPageLoading,
  setHasMore,
  setError,
  setSuccess,
  setNewsMobile
} = loadingSlice.actions;
export default loadingSlice.reducer;
